(function($, window, undefined) {
  if (window.mg === undefined)
    window.mg = {};

  if (window.mg.ui === undefined)
    window.mg.ui = {};

  const _ = window.mg;

  const initClearer = (that) => {
    that._$ddl.on('loaded.bs.select', () => {
      const $parent  = that._$ddl.parent();
      const $menu    = $('> .dropdown-menu', $parent);
      const $input   = $('input[type="text"]', $menu);
      const instance = _.ui.clearer($input);

      instance._$input.on('keyup.clearer', (e) => {
        const downOnTab  = e.which === 9 && !that.sp.options.selectOnTab;
        const isArrowKey = e.which === 38 || e.which === 40 || downOnTab;

        if (isArrowKey)
          e.stopPropagation();
        else
          instance._$input.trigger('input');
      });

      instance._$input.on('keydown.clearer', (e) => {
        if (instance._$input.val().length >= 1 && e.which === 27)
          e.stopPropagation();
      });

      instance._$clearer.on('click.clearer', (e) => {
        instance._$input.trigger('input');

        e.stopPropagation();
      });
    });
  };

  const destroyClearer = (that) => {
    const $parent = that._$ddl.parent();
    const $menu   = $('> .dropdown-menu', $parent);
    const $input  = $('input[type="text"]', $menu);

    _.ui.clearer.destroy($input)
  };

  class Select {
    constructor(ddl, options) {
      this._$ddl    = $(ddl);
      this._options = $.extend({}, this._$ddl.data(), options);

      return this._$ddl.data('ui.select') || this.init();
    }

    init() {
      if (this._$ddl.data('ui.select'))
        return this;

      const opts = $.extend(true, {}, this._options);

      if (opts.events)
        delete opts.events;

      const plugin = $.fn.selectpicker.call(this._$ddl, opts);

      this.sp = plugin.data('selectpicker');

      if (this._options.liveSearch)
        initClearer(this);

      this._options.events && $.each(this._options.events, (i, v) => {
        this._$ddl.on(v.name + '.bs.select', v.callback);
      });

      this._$ddl.data('ui.select', this);

      return this;
    }

    destroy() {
      return Select.destroy(this._$ddl);
    }

    static destroy(ddl) {
      const $ddl     = $(ddl);
      const instance = $ddl.data('ui.select');

      if (!instance)
        console.warn('The select is not initialised');

      if (instance._options.liveSearch)
        destroyClearer(instance);

      instance.sp.destroy();
      instance._$ddl.removeData('ui.select');

      return instance;
    }
  }

  _.ui.select         = (ddl, options) => new Select(ddl, options);
  _.ui.select.destroy = (ddl) => Select.destroy(ddl);
  _.ui.select.get     = (ddl) => $(ddl).data('ui.select');

  $(window).off('load.bs.select.data-api');
})(jQuery, window);
